var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"type":"article"}},[_c('FormViewer',{attrs:{"displayTitle":"","readOnly":_vm.readOnly,"saved":_vm.saved,"submissionId":_vm.submissionId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }